export enum ChartTypeEnum {
   PIE = "PIE",
   BAR = "BAR",
   SIN = "SIN",
}
